export const formatPriceModal = (v?: number) =>
    v !== undefined ? v.toLocaleString('ru-RU', {minimumFractionDigits: 2}) : '';
